import React, { useEffect, useState, useRef } from 'react';
import {withRouter} from 'react-router-dom';
import useWindowSize from '../../../hooks/useWindowSize';

import moment from 'moment';
import { connect } from 'react-redux';
import { process as kendoProcess, orderBy, filterBy } from '@progress/kendo-data-query';
import { getter } from '@progress/kendo-react-common';
import { array, object } from 'prop-types';
import { cloneDeep } from 'lodash';
import { Grid, GridColumn as Column, getSelectedState } from '@progress/kendo-react-grid';
import BobLoadingMask from '../../../components/BobLoadingMask';
import BobTableContextMenu from '../../../components/BobTableContextMenu';
import TotalsPanel from '../../../components/TotalsPanel';
import BobActionMenu from '../../../components/BobActionMenu';
import * as BobActions from '../../../actions/bobActions';
import * as WorkerActions from '../../../actions/workerActions';
import DeleteJobModal from './DeleteJobModal';
import { getTimeZoneAbbr } from '../../../helpers/timezones';
import classes from './Table.module.css';
import aclasses from './BackgroundJobsList.module.css';
import BobWorkbookModeButton from '../../../components/BobWorkbookModeButton';
import {calculateMinColumnWidths} from '../../../helpers/calculateMinColumnWidths';
import { kendoGridInlineStyling } from '../../../helpers/kendoGridInlineStyleHelper';
import * as DashboardActions from '../../../actions/dashboardActions';

const idGetter = getter('processId');

const BackgroundJobsList = ({
    activeNavCompany,
    bobLoading,
    fetchBackgroundJobs,
    deleteWorkerJobs,
    history,
    backgroundJobs,
    deleteWorkerJob,
    currentUser,
    setWorkBookMode,
    workbookModeEnabled,
    ...props
}) => {

    const initialDataState = {
        take:   10,
        skip:   0,
        filter: [],
        sort:   []
    };

    const [selectedStateItems, setSelectedStateItems] = useState({});
    const [selectedState, setSelectedState] = useState({});
    const [pageable] = useState({ pageSizes: true });
    const [deleteModal, setDeleteModal] = useState(false);
    // eslint-disable-next-line no-unused-vars
    const [showMsg, setShowMsg] = useState(false);
    const [currentJob, setCurrentJob] = useState(null);
    const [gridDataState, setGridDataState] = useState(initialDataState);
    const [processNameColumnWidth, setProcessNameColumnWidth] = useState(500);
    const [take, setTake] = useState(10);

    const gridDivRef = useRef(null);
    const gridRef = useRef(null);

    const windowSize = useWindowSize();

    useEffect(() => {
        const columns = gridRef.current.props.children;
        setProcessNameColumnWidth(calculateMinColumnWidths(columns, gridDivRef.current.offsetWidth, 'processType', 500, true));
    }, [windowSize]);

    useEffect(() => {
        if (activeNavCompany.id) {
            getbackgroundJobs();
        }
    }, [activeNavCompany.id]);

    useEffect(() => {
        if (!workbookModeEnabled) {
            initialDataState.take = take;
            setGridDataState(initialDataState);
        }
    }, [workbookModeEnabled]);

    const getbackgroundJobs = () => {
        const init = async () => {
            await fetchBackgroundJobs(currentUser.id, activeNavCompany.id);
        };
        init();
    };

    const handleClickAction = (actionType) => {
        switch (actionType) {
            case 'active':
                break;
            case 'inactive':
                break;
            case 'delete':
                handleAnnouncementDelete(null);
                break;
            default:
                break;
        }
    };

    const handleJobClick = (announcement) => {
        if (currentUser.isSuperUser) {
            setCurrentJob(announcement);
        }
        else {
            setCurrentJob(announcement);
            setShowMsg(true);
        }
    };


    const fetchUserData = (requestData, actionType) => {
        switch (actionType) {
            case 'select':
                handleJobClick(requestData);
                break;
            case 'delete':
                handleAnnouncementDelete(requestData);
                break;
            case 'clone':
                handleJobClick(requestData, 'clone');
                break;
            default:
                break;
        }
    };

    const renderTimeStamp = props => {
        const zone = moment.tz.guess();
        return (
            <td className={props.className} style={props.style}>
                <div>{moment(props.dataItem.timestamp).format('YYYY-MM-DD h:mm A') + ' ' + getTimeZoneAbbr(moment(props.dataItemtimestamp), zone)}</div>
            </td>
        );
    };

    const handleWorkbookMode = () => {
        setWorkBookMode(!workbookModeEnabled);
    };

    const actionsCell = props => {
        return (
            <td className={props.className} style={props.style}>
                <BobTableContextMenu
                    type="BackgroundJobs"
                    entityData={props.dataItem}
                    onFetch={(requestData, actionType) => fetchUserData(requestData, actionType)}
                />
            </td>
        );
    };

    const handleAnnouncementDelete = (announcement) => {
        setCurrentJob(announcement);
        setDeleteModal(true);
    };

    const handleCloseDeleteModal = (announcement) => {
        setDeleteModal(false);
    };

    const handleDelete = () => {
        const deleteJobList = async (items) => {
            if (items.length === 0) {
                let response = await deleteWorkerJob(currentJob.processId, currentJob.processGroupId);
                getbackgroundJobs(response);
            }
            else {
                let response = await deleteWorkerJobs(items);
                getbackgroundJobs(response);
            }
        };

        if (currentJob && currentJob.processId) {
            deleteJobList([]);
        }
        else {
            let items = [];
            for (const processId in selectedStateItems) {
                items.push(selectedStateItems[processId]);
            }
            if (items.length > 0) {
                deleteJobList(items);
            }
        }
    };

    const onSelectionChange = (event) => {
        const newSelectedState = getSelectedState({
            event,
            selectedState: selectedState,
            dataItemKey:   'processId'
        });

        setSelectedState(newSelectedState);

        if (event && event.dataItem) {
            let data = selectedStateItems;
            let id = event.dataItem.processId;

            if (data[id]) {
                delete data[id];
            } else {
                data[id] = event.dataItem;
            }

            setSelectedStateItems(data);
        }
    };

    const onHeaderSelectionChange = event => {
        const checkboxElement = event.syntheticEvent.target;
        const checked = checkboxElement.checked;
        const newSelectedState = cloneDeep(selectedState);
        let selectedStateItems = {};

        const filteredData = orderBy(filterBy(backgroundJobs, gridDataState.filter), gridDataState.sort);
        filteredData.forEach((item) => {
            newSelectedState[idGetter(item)] = checked;
            if (checked) {
                selectedStateItems[idGetter(item)] = item;
            }

        });
        if (!checked) {
            selectedStateItems = {};
        }
        setSelectedState(newSelectedState);
        setSelectedStateItems(selectedStateItems);
    };

    const getStatusCount = (status) => {
        const filteredData = orderBy(filterBy(backgroundJobs, gridDataState.filter), gridDataState.sort);
        if (filteredData.length === 0) {
            return 0;
        }

        const statusCount = filteredData.filter(a => a.status.toLowerCase() === status.toLowerCase()).length;
        return statusCount;
    };

    const onDataStateChange = e => {
        setTake(e.dataState.take);
        setGridDataState(e.dataState);
    };

    const refreshGrid = async () => {
        await fetchBackgroundJobs(currentUser.id, activeNavCompany.id);
    };

    return (
        <div className={`announcement-table jobs-table ${classes.Table}`}>
            <div className={classes.TableContainerHead}>
                <div className={classes.TotalsContainer}>
                    <div className={aclasses.WorkbookModeContainer}>
                        <BobWorkbookModeButton
                            handleWorkbookMode={handleWorkbookMode}
                            workbookMode={workbookModeEnabled}
                        />
                    </div>
                    <TotalsPanel
                        data={{ complete: getStatusCount('complete'), failed: getStatusCount('failed'), inProgress: getStatusCount('inprocess') }}
                        entityType={'BackgroundJobs'}
                    />
                </div>
                <div
                    className={classes.RefreshContainer}
                    aria-hidden="true"
                    role="button"
                    tabIndex={0}
                    onClick={refreshGrid}
                >
                    <span className="material-icons-outlined">refresh</span>
                </div>
                {currentUser.isSuperUser ?
                    <div className={classes.ActionButtonContainer}>
                        <BobActionMenu
                            type="BackgroundJobs"
                            handleDelete={() => handleClickAction('delete')}
                        />
                    </div>
                    : ''}
            </div>
            <React.Fragment>
                <style>
                    { kendoGridInlineStyling }
                </style>
                <div ref={gridDivRef} className={classes.Table}>
                    <Grid
                        ref={gridRef}
                        data={kendoProcess(backgroundJobs ? backgroundJobs.map(item => ({
                            ...item,
                            'selected': selectedState[idGetter(item)],
                        })) : [], gridDataState)}
                        {...gridDataState}
                        filterable={workbookModeEnabled}
                        pageable={pageable}
                        onDataStateChange={onDataStateChange}
                        sortable={{
                            mode: 'multiple'
                        }}
                        className={aclasses.KendoGrid}
                        dataItemKey={'processId'}
                        selectedField={'selected'}
                        selectable={{
                            enabled: true,
                            drag:    false,
                            cell:    false,
                            mode:    'multiple'
                        }}
                        onSelectionChange={onSelectionChange}
                        onHeaderSelectionChange={onHeaderSelectionChange}
                        reorderable
                    >
                        <Column
                            field="selected"
                            width="70px"
                            headerSelectionValue={
                                orderBy(filterBy(backgroundJobs, gridDataState.filter), gridDataState.sort).length > 0 && 
                                orderBy(filterBy(backgroundJobs, gridDataState.filter), gridDataState.sort).findIndex((item) => !selectedState[idGetter(item)]) === -1
                            }
                            filterable={false}
                            sortable={false}
                        />
                        <Column
                            sortable={true}
                            title="Process"
                            width={processNameColumnWidth}
                            field="processType"
                        />
                        <Column
                            title="Status"
                            width="250px"
                            field="status"
                        />
                        <Column
                            title="Completed On"
                            width="250px"
                            field="timestamp"
                            filter={'date'}
                            cell={renderTimeStamp}
                        />
                        <Column
                            field=""
                            title=""
                            width="60px"
                            cell={actionsCell}
                            locked={true}
                            filterable={false}
                            sortable={false}
                        />
                    </Grid>
                </div>
            </React.Fragment>
            {deleteModal ?
                <DeleteJobModal
                    open={deleteModal}
                    close={(job) => handleCloseDeleteModal(job)}
                    handleDelete={handleDelete}
                    currentJob={currentJob}
                    message={`${currentJob ? `Are you sure you want to delete ${currentJob.processType}?` : `Are you sure you want to delete the selected jobs?`}`}
                    title={`Confirm Delete: ${currentJob ? currentJob.processType : 'Background Jobs'}`}
                />
                : ''}
            {
                bobLoading.includes('BackgroundJobs') ?
                    <BobLoadingMask
                        className={classes.Loader}
                    />
                    :
                    null
            }

        </div>
    );
};

BackgroundJobsList.defaultProps = {
    backgroundJobList: [],
    currentUser:       {}
};

BackgroundJobsList.propTypes = {
    backgroundJobList: array,
    currentUser:       object
};

const mapStateToProps = state => ({
    activeNavCompany:    state.bob.activeNavCompany,
    bobLoading:          state.bob.bobLoading,
    backgroundJobs:      state.worker.backgroundJobs,
    currentUser:         state.currentUser,
    workbookModeEnabled: state.dashboard.workbookModeEnabled
});

const mapDispatchToProps = ({
    ...BobActions,
    ...WorkerActions,
    ...DashboardActions
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(BackgroundJobsList));
